import { useCallback, useState } from 'react'

export interface EvidenceLayers {
  phone: boolean
  email: boolean
  location: boolean
}

const DEFAULT_EVIDENCE_LAYERS: EvidenceLayers = {
  phone: true,
  email: true,
  location: true,
}

export function useEvidenceLayers() {
  const [evidenceLayers, setEvidenceLayers] = useState<EvidenceLayers>(DEFAULT_EVIDENCE_LAYERS)

  const handleEvidenceToggle = useCallback((layer: keyof EvidenceLayers) => {
    setEvidenceLayers(prev => ({ ...prev, [layer]: !prev[layer] }))
  }, [])

  return { evidenceLayers, handleEvidenceToggle }
}
